let aboutNav = document.querySelector(".about-nav");
let header = document.querySelector("header");
let navLinks = document.querySelectorAll(".about-nav a");
let anchors = document.querySelectorAll(".anchor");
let lastScrollY = window.scrollY;

let updateActiveLink = () => {
  if (!navLinks.length || !anchors.length) return;

  let offset = 56;
  let activeAnchor = anchors[0];

  anchors.forEach((anchor) => {
    if (anchor.getBoundingClientRect().top <= offset + 1) {
      activeAnchor = anchor;
    }
  });

  navLinks.forEach((link) => {
    link.classList.toggle(
      "active",
      link.getAttribute("href") === `#${activeAnchor.id}`,
    );
  });
};

let handleScroll = () => {
  let currentScrollY = window.scrollY;
  let scrollingUp = currentScrollY < lastScrollY;

  if (aboutNav) {
    aboutNav.classList.toggle("sticky", currentScrollY > 56);
  }

  if (header) {
    if (currentScrollY <= 56 || scrollingUp) {
      header.classList.remove("header-hidden");
    } else {
      header.classList.add("header-hidden");
    }
  }

  updateActiveLink();
  lastScrollY = currentScrollY;
};

handleScroll();
requestAnimationFrame(handleScroll);

window.addEventListener("load", handleScroll);
window.addEventListener("scroll", handleScroll);
window.addEventListener("resize", updateActiveLink);